<template>
  <div class="main">
    <div class="body-content">
      <div class="page-header">
          <h1>Vessel Positions</h1>
      </div>
      <!-- Filter Options -->
      <div class="filter-section">
        <div class="filter-tabs">
          <button :class="['filter-tab', { active: activeFilter === 'vessel' }]" @click="activeFilter = 'vessel'">
            Vessel/Voyage/Location
          </button>
          <button :class="['filter-tab', { active: activeFilter === 'move' }]" @click="activeFilter = 'move'">
            Move
          </button>
          <button :class="['filter-tab', { active: activeFilter === 'berth' }]" @click="activeFilter = 'berth'">
            Berth
          </button>
        </div>

        <div class="filter-content">
          <!-- Vessel/Voyage/Location Filter -->
          <div v-if="activeFilter === 'vessel'" class="filter-form">
            <div class="form-group">
              <div class="form-item2">
                <label for="vcnname">VCN No *</label>
                <v-select :clearable="false" id="vcnname" v-model="vcnID" :options="vcns" label="vcnName"
                  :reduce="vcn => vcn.vcnID" selectOnTab="True" />
              </div>
              <div class="form-item2">
                <label for="vesselName">Vessel *</label>
                <v-select :clearable="false" id="vesselName" placeholder="Select Vessel" v-model="vesselID"
                  ref="vesselName" :options="vessel" label="Name" :reduce="vessel => vessel.Vesselid"
                  selectOnTab="True" />
              </div>
              <div class="form-item4">
                <label for="voyageName">Voyage *</label>
                <v-select :clearable="false" id="voyageName" v-model="voyageID" :options="voyage" label="Name"
                  :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
              </div>
              <div class="form-item4">
                <label for="area">Area *</label>
                <select v-model="loc" id="area" class="form-input" style="margin:0;">
                  <option value="">Select Area</option>
                  <option v-for="loc in locations" :key="loc" :value="loc">{{ loc }}</option>
                </select>
              </div>
              <div class="form-item4">
                <button @click="searchVesselPositions(1)" class="btn-search" :disabled="isLoading"
                  style="height: fit-content; margin-top: 21px;">
                  <i v-if="!isLoading" class="fas fa-search"></i>
                  <i v-else class="fas fa-spinner fa-spin"></i>
                  Search
                </button>
              </div>
            </div>
          </div>
          <!-- Move Filter -->
          <div v-if="activeFilter === 'move'" class="filter-form">
            <div class="form-group">
              <div class="form-item2">
                <label for="move-type">Move Type *</label>
                <select v-model="move" id="move-type" class="form-input">
                  <option value="">Select Move</option>
                  <option v-for="m in movelist" :key="m" :value="m">{{ m }}</option>
                </select>
              </div>
              <div class="form-item2">
                <button @click="searchVesselPositions(2)" class="btn-search" :disabled="isLoading || !move"
                  style="height: fit-content; margin-top: 21px;">
                  <i v-if="!isLoading" class="fas fa-search"></i>
                  <i v-else class="fas fa-spinner fa-spin"></i>
                  Search
                </button>
              </div>
            </div>
          </div>

          <!-- Berth Filter -->
          <div v-if="activeFilter === 'berth'" class="filter-form">
            <div class="form-group">
              <div class="form-item2">
                <label for="berth">Berth *</label>
                <select v-model="berth" id="berth" class="form-input">
                  <option value="">Select Berth</option>
                  <option v-for="p in placelist" :key="p" :value="p">{{ p }}</option>
                </select>
              </div>
              <div class="form-item2">
                <button @click="searchVesselPositions(3)" class="btn-search" :disabled="isLoading"
                  style="height: fit-content; margin-top: 21px;">
                  <i v-if="!isLoading" class="fas fa-search"></i>
                  <i v-else class="fas fa-spinner fa-spin"></i>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="isLoading" class="loading-state">
      <p>Loading vessel positions...</p>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="error-state">
      <p>{{ error }}</p>
      <button @click="clearError" class="btn-retry">Dismiss</button>
    </div>

    <!-- Results Table -->
    <div v-else-if="positions.length > 0" class="table-container">
      <div class="result-info">
        <p>Found {{ positions.length }} position(s)</p>
      </div>
      <v-data-table :headers="tableHeaders" :items="tableData" :items-per-page="pageSize" v-model:page="currentPage"
        class="elevation-1"></v-data-table>
    </div>

    <!-- No Results -->
    <div v-else-if="searched" class="no-results">
      <p>No vessel positions found. Try adjusting your filters.</p>
    </div>

    <!-- Initial State -->
    <div v-else class="initial-state">
      <p>Select a filter option and search to view vessel positions</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import VSelect from 'vue-select';
export default {
  name: 'VesselPositions',
  setup() {
    const toast = useToast();
    return { toast };
  },
  components: {
    VSelect,
  },
  data() {
    return {
      activeFilter: 'vessel',
      vessel: JSON.parse(localStorage.getItem('vessel')) || [],
      voyage: JSON.parse(localStorage.getItem('voyage')) || [],
      vcns: JSON.parse(localStorage.getItem('vcnall')) || [],
      vesselID: 0,
      voyageID: 0,
      vcnID: 0,
      move: '',
      berth: '',
      loc: '',
      movelist: ["Arrived", "Waiting", "Berth", "Commenced", "Suspended", "Resumed", "Completed", "Sailing"],
      placelist: ["Sandheads", "BUOYS", "NA", "1 NSD", "2NSD", "3 NSD", "4 NSD", "5 NSD", "6 NSD", "7 NSD", "8 NSD", "11 NSD", "12 NSD", "13 NSD", "14 NSD", "1 HDC", "2 HDC", "3 HDC", "4 HDC", "5 HDC", "6 HDC", "7 HDC", "8 HDC"],
      locations: ["Kolkata", "Haldia"],
      filters: {
        vesselid: 0,
        voyageid: 0,
        loc: '',
        move: '',
        berth: '',
      },
      positions: [],
      isLoading: false,
      error: null,
      searched: false,
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    formattedVessels() {
      return Array.isArray(this.vessel) ? this.vessel.map(v => ({
        id: v.vesselid,
        title: v.vessel_name || v.vesselid || 'Unknown Vessel'
      })) : [];
    },
    formattedVoyages() {
      return Array.isArray(this.voyage) ? this.voyage.map(v => ({
        id: v.voyageid,
        title: v.voyage_name || v.voyageid || 'Unknown Voyage'
      })) : [];
    },
    tableHeaders() {
      switch (this.activeFilter) {
        case 'move':
          return [
            { title: 'VCN No', key: 'vcnName' },
            { title: 'Vessel Name', key: 'vessname' },
            { title: 'Export Voyage', key: 'exp_voy' },
            { title: 'Import Voyage', key: 'imp_voy' },
            { title: 'Terminal', key: 'area' },
            { title: 'Berth', key: 'place' },
            { title: 'Last Move', key: 'move' },
            { title: 'Move Date', key: 'movedate' },
            { title: 'Move Time', key: 'movetime' },
          ];
        case 'berth':
          return [
            { title: 'VCN No', key: 'vcnName' },
            { title: 'Vessel Name', key: 'vessname' },
            { title: 'Export Voyage', key: 'exp_voy' },
            { title: 'Import Voyage', key: 'imp_voy' },
            { title: 'Terminal', key: 'area' },
            { title: 'Berth', key: 'place' },
            { title: 'Last Move', key: 'move' },
            { title: 'Move Date', key: 'movedate' },
            { title: 'Move Time', key: 'movetime' },
          ];
        case 'vessel':
        default:
          return [
            { title: 'Sl. No', key: 'slno' },
            { title: 'Move Name', key: 'move' },
            { title: 'Terminal', key: 'terminal' },
            { title: 'Berth', key: 'place' },
            { title: 'Date', key: 'movedate' },
            { title: 'Time', key: 'movetime' },
          ];
      }
    },
    tableData() {
      return this.positions.map((position, index) => {
        if (this.activeFilter === 'vessel') {
          return {
            slno: index + 1,
            move: position.move,
            terminal: position.terminal,
            place: position.place,
            movedate: this.formatDate(position.movedate),
            movetime: position.movetime,
          };
        } else if (this.activeFilter === 'move') {
          return {
            vcnName: position.vcnName || position.vcn_no || position.vessel_code || '-',
            vessname: position.vessname || position.vessel_name || position.vessel || '-',
            exp_voy: position.exp_voy || position.export_voyage || position.export_voy || '-',
            imp_voy: position.imp_voy || position.import_voyage || position.import_voy || '-',
            area: position.area || position.terminal || '-',
            place: position.place || position.berth_place || '-',
            move: position.move || position.last_move || '-',
            movedate: this.formatDate(position.movedate),
            movetime: position.movetime || '-',
          };
        } else if (this.activeFilter === 'berth') {
          return {
            vcnName: position.vcnName || position.vcn_no || position.vessel_code || '-',
            vessname: position.vessname || position.vessel_name || position.vessel || '-',
            exp_voy: position.exp_voy || position.export_voyage || position.export_voy || '-',
            imp_voy: position.imp_voy || position.import_voyage || position.import_voy || '-',
            area: position.area || position.terminal || '-',
            place: position.place || position.berth_place || '-',
            move: position.move || position.last || position.last_move || '-',
            movedate: this.formatDate(position.movedate),
            movetime: position.movetime || '-',
          };
        }
        return position;
      });
    },
  },
  watch: {
    'vcnID'(value) {
        this.FillVCNDetails(value)
    },
    activeFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.positions = [];
        this.searched = false;
        this.error = null;
      }
    },
  },
  methods: {
    FillVCNDetails(value) {
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            //console.log('Selected VCN details:', selvcn);
            if (selvcn && selvcn.vcnID !== 0) {
                this.vesselID = selvcn.vesselID;
                this.voyageID = selvcn.export_voyage;
                this.areaID = selvcn.MlocID; // Assuming MlocID corresponds to Area
                if (selvcn.MlocID == 210 || selvcn.MlocID == 211) {
                    this.loc = "Kolkata";
                } else if (selvcn.MlocID == 46) {
                    this.loc = "Haldia";
                } else {
                    this.loc = "";
                }
            } 
        },
        updateVCNFromVesselAndVoyage() {
            this.vcnID = 0; // Reset VCN ID when vessel or voyage changes
            if (this.vesselID && this.voyageID && this.areaID) {
                const matchingVcn = this.vcns.find(vcn => vcn.vesselID === this.vesselID && vcn.export_voyage === this.voyageID && vcn.MlocID === this.areaID);
                if (matchingVcn) {
                    this.vcnID = matchingVcn.vcnID;
                }
            }
        },
    async searchVesselPositions(filterType) {
      this.isLoading = true;
      this.error = null;
      this.searched = true;

      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };

        // Map local properties to filters object
        this.filters.vesselid = this.vesselID;
        this.filters.voyageid = this.voyageID;
        this.filters.move = this.move;
        this.filters.berth = this.berth;
        this.filters.loc = this.loc;

        let url = '/get_vessels_positions?filter_type=' + filterType;

        if (filterType === 1) {
          // Vessel/Voyage/Location filter
          if (this.filters.vesselid == "" || this.filters.voyageid == "" || this.filters.loc == "") {
            this.error = 'Please enter all required fields for Vessel/Voyage/Location filter';
            this.isLoading = false;
            return;
          }
          if (this.filters.vesselid) url += '&vesselid=' + this.filters.vesselid;
          if (this.filters.voyageid) url += '&voyageid=' + this.filters.voyageid;
          if (this.filters.loc) url += '&loc=' + encodeURIComponent(this.filters.loc);
        } else if (filterType === 2) {
          // Move filter
          if (!this.filters.move) {
            this.error = 'Please select a move type';
            this.isLoading = false;
            return;
          }
          url += '&move=' + encodeURIComponent(this.filters.move);
        } else if (filterType === 3) {
          // Berth filter
          if (!this.filters.berth) {
            this.error = 'Please enter a berth';
            this.isLoading = false;
            return;
          }
          url += '&berth=' + encodeURIComponent(this.filters.berth);
        }

        //console.log('Fetching vessel positions from:', url);
        const response = await axios.get(url, config);
        //console.log('Vessel positions response:', response.data);

        this.positions = response.data[2];

        if (this.positions.length === 0) {
          this.toast.info('No vessel positions found for the selected criteria');
        } else {
          this.toast.success('Vessel positions loaded successfully');
        }
      } catch (error) {
        console.error('Error fetching vessel positions:', error);
        this.error = error.response?.data?.message || 'Failed to fetch vessel positions. Please try again.';
        this.toast.error(this.error);
        this.positions = [];
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      try {
        // If format is yyyy-mm-dd, parse it directly
        if (typeof dateString === 'string' && dateString.includes('-')) {
          const parts = dateString.split('-');
          if (parts.length === 3) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`; // dd/mm/yyyy
          }
        }
        // Fallback to Date parsing
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      } catch (e) {
        return dateString;
      }
    },

    clearError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #FFF;
  width: 100%;
}

.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.form-item {
  width: 32%;
}

.form-item2 {
  width: 24%;
}

.form-item3 {
  width: calc(50% - 10px);
  margin-right: 10px;
}
.form-item4 {
  width: 16%;
}

.vessel-positions-container {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header h1 {
  margin: 0;
  font-size: 28px;
  color: #333;
}

.filter-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
  padding: 10px 20px;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

.filter-tab {
  background: none;
  border: none;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: #666;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  margin-bottom: -2px;
}

.filter-tab:hover {
  color: #333;
}

.filter-tab.active {
  color: #4CAF50;
  border-bottom-color: #4CAF50;
}

.filter-content {
  margin-top: 10px;
}

.filter-form {
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-end;
}

/* Vue Select styling */
::v-deep(.vs__dropdown-toggle) {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #FFF;
  padding: 0;
}

::v-deep(.vs__dropdown-toggle:hover) {
  border-color: #4CAF50;
}

::v-deep(.vs__dropdown-toggle.vs--open) {
  border-color: #4CAF50;
}

::v-deep(.vs__search::placeholder) {
  color: #999;
}

.btn-search {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.btn-search:hover:not(:disabled) {
  background-color: #45a049;
}

.btn-search:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.loading-state,
.error-state,
.no-results,
.initial-state {
  background: white;
  padding: 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.error-state {
  color: #d32f2f;
}

.error-state p {
  margin-bottom: 15px;
}

.btn-retry {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.btn-retry:hover {
  background-color: #45a049;
}

.result-info {
  margin-bottom: 15px;
  font-size: 14px;
  color: #666;
  font-weight: 600;
}

.no-results,
.initial-state {
  color: #999;
}

.no-results p,
.initial-state p {
  font-style: italic;
  margin: 0;
}
</style>
